module.exports = __webpack_public_path__ + "img/ARCTERYX-icon.25b3b072.png";